/**
 * Palmo SDK Error Codes
 */
const ERROR_CODES = {
    INVALID_CONFIG: 'INVALID_CONFIG',
    API_ERROR: 'API_ERROR',
    NETWORK_ERROR: 'NETWORK_ERROR',
    AUTH_TIMEOUT: 'AUTH_TIMEOUT',
    AUTH_FAILED: 'AUTH_FAILED',
    RATE_LIMIT: 'RATE_LIMIT',
    INVALID_SESSION: 'INVALID_SESSION',
    AUTH_CANCELLED: 'AUTH_CANCELLED',
    SIGNATURE_INVALID: 'SIGNATURE_INVALID',
};

/**
 * Palmo SDK Environments
 */
const ENVIRONMENTS = {
    PRODUCTION: 'https://palmo.orcib.com',
    SANDBOX: 'https://dev-palmo.orcib.com',
    LOCAL: 'http://localhost:9001'
};

const MARKET_ENVIRONMENTS = {
    PRODUCTION: 'https://market.orcib.com',
    SANDBOX: 'https://dev-market.orcib.com',
    LOCAL: 'http://localhost:9002'
};

/**
 * Event Types
 */
const EVENT_TYPES = {
    QR_DISPLAYED: 'qr_displayed',
    SCAN_DETECTED: 'scan_detected',
    AUTH_SUCCESS: 'auth_success',
    AUTH_FAILED: 'auth_failed',
    STATUS_CHANGED: 'status_changed',
};

module.exports = {
    ERROR_CODES,
    ENVIRONMENTS,
    MARKET_ENVIRONMENTS,
    EVENT_TYPES,
    EVENTS: EVENT_TYPES, // Alias used by index.js
};
